import '@babel/polyfill'

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS

//////////////////////////////////////////////////////////////// Side Menu
import SideMenu from './plugins/side-menu/index.js'
Vue.use(SideMenu)

//////////////////////////////////////////////////////////////// Collapse (Accordion)
import {
    CollapsePlugin
} from 'bootstrap-vue'
Vue.use(CollapsePlugin)

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -120,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

//////////////////////////////////////////////////////////////// Bootstrap Modal
import {
    ModalPlugin
} from 'bootstrap-vue'
Vue.use(ModalPlugin)

//////////////////////////////////////////////////////////////// Form validation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS

//////////////////////////////////////////////////////////////// Background Video
import BgVideo from './components/bg-video/index.vue'
Vue.component('bg-video', BgVideo)

//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/index.vue'
Vue.component('bg-image', BgImage)

//////////////////////////////////////////////////////////////// Text Wings
import TextWings from './components/text-wings/index.vue'
Vue.component('text-wings', TextWings)

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES

//////////////////////////////////////////////////////////////// Sticky Header
import StickyHeader from './directives/sticky-header/index.js'
Vue.directive('sticky-header', StickyHeader)

//////////////////////////////////////////////////////////////// Fancy box
import FancyBox from './directives/fancy-box/index.js'
Vue.directive('fancy-box', FancyBox)

//////////////////////////////////////////////////////////////// Sticky Directive
import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)

/////////////////////////////////////////////////////////////////////////////////////////////////// FILTERS

/////////////////////////////////////////////////////////////////////////////////////////////////// APP

//////////////////////////////////////////////////////////////// Bit.dev
import CookiesMsg from './components/cookies-msg/index.vue'
// import SideMenu from './components/side-menu/index.vue'
import GoogleMap from './components/google-map/index.vue'

//////////////////////////////////////////////////////////////// Local
import ExclusivitiesCarousel from './exclusivities-carousel.vue'
import PhotosCarousel from './photos-carousel.vue'
import ContactForm from './contact-form.js'
import ProductsList from './products-list'
import NewsList from './news-list'

import {
    isIE,
    // devices
} from './imports/utils'

var app = new Vue({
    el: '#app',
    components: {
        CookiesMsg,
        // SideMenu,
        ExclusivitiesCarousel,
        PhotosCarousel,
        ContactForm,
        NewsList,
        ProductsList,
        GoogleMap
    },
    data() {
        return {
            lang: document.getElementById('app').getAttribute('lang'),
            isIE: isIE(),
            sideMenuOpen: false,
            windowWidth: window.innerWidth
            // isDevice: devices(),
        }
    },
    methods: {
        updateSideMenu() {
            this.sideMenuOpen = !this.sideMenuOpen
        },
        onResize() {
            this.windowWidth = window.innerWidth
        },
    },
    created() {
        // window.addEventListener("resize", this.onResize, {
        //     passive: false
        // });

        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')
    },
    destroyed() {
        // window.removeEventListener("resize", this.onResize)
    }
})